<template>
  <div>
    <!-- <mheader></mheader> -->
    <div
      v-show="tableData.length > 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2">
          <img
            src="../../static/images/kucun_1.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            结算查询
          </span>
          <span class="ml-5">
            <span>
              显示<span class="record">{{ PageNo }}</span
              >-<span class="record">{{ Pcount }}</span
              >页,
            </span>
            <span>
              总共<span class="record">{{ Record }}</span
              >条数据
            </span>
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>
        <div>
          <table class="table table-striped table-hover sett" ref="print">
            <thead>
              <tr style="white-space: nowrap" @click="changeWidth($event)">
                <th style="width: 59px">日期</th>
                <th style="width: 74px">余额</th>
                <!-- <th class="autocut">第一天销售额(大前天)</th> -->
                <!-- <th class="autocut">第二天销售额(前天)</th> -->
                <!-- <th class="autocut">第三天销售额(昨天)</th> -->
                <th class="autocut">货物前移金额(45天)</th>
                <th class="autocut">当天销售额</th>
                <th class="autocut">限结算金额</th>
                <th class="autocut">欠发票笔次</th>
                <th class="autocut">最早欠发票日期</th>
                <th class="autocut">欠发票延期</th>
                <th class="autocut">欠发票限结款</th>
                <th class="autocut">欠入库手续限结款</th>
                <th class="autocut">担保限结款日期</th>
                <th class="autocut">担保限结款金额</th>
                <th class="autocut">是否与其他代理商捆绑</th>
                <th class="autocut">近效期品种数和过期品种数</th>
                <th class="autocut">限制库存最低金额</th>
                <th class="autocut">销售利润为负未审核</th>
                <th class="autocut">两个月未入库未审核</th>
                <th class="autocut">销售小于上月50%未审核</th>
                <th style="width: 81px">可结算金额</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in tableData"
                :key="index"
                style="white-space: nowrap"
              >
                <td>{{ item.date }}</td>
                <td>{{ item.balanceMoney }}</td>
                <!-- <td></td> -->
                <!-- <td class="text-center">{{item.sales2nd}}</td> -->
                <!-- <td class="text-center">{{item.sales3rd}}</td> -->
                <td>{{ item.goodsForwardMoney }}</td>
                <td class="text-center">{{ item.sales4th+item.currentDayGoodsForwardMoney }}</td>
                <td class="text-center">{{ item.limitMoney }}</td>
                <td class="text-center">{{ item.owedInvoiceNum }}</td>
                <td class="sett-td">{{ item.earliestOwedDate }}</td>
                <td class="text-center">{{ item.delayDay }}</td>
                <td class="text-center">{{ item.limitInvoiceMoney }}</td>
                <td class="text-center">{{ item.limitOwedProcessMoney }}</td>
                <td class="text-center">{{ item.guaranteeDate }}</td>
                <td class="text-center">{{ item.guaranteeMoney }}</td>
                <td class="text-center">
                  {{ item.isBindingOthers | getTrue }}
                </td>
                <td class="text-center">{{ item.warningDueNum }}</td>
                <td class="text-center">{{ item.limitStoreMoney }}</td>
                <td>{{ item.notVerifiedNegativeProfit | getTrue }}</td>
                <td>{{ item.notVerifiedNotInStore | getTrue }}</td>
                <td>{{ item.notVerifiedLessThanHalfLastMonth | getTrue }}</td>
                <td>{{ item.canSettlementMoney }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 分页 -->
        <div class="row m-0" style="margin:0 auto;">
          <nav
            aria-label="Page navigation"
            style="text-align: center"
            v-if="this.Pcount !== 0"
            class="mb-1"
          >
            <ul class="pagination">
              <li
                class="page-item ml-5"
                :class="PageNo <= 1 ? 'disabled' : ''"
                @click="prePage()"
              >
                <a aria-label="Previous" class="page-link">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li
                :class="index == PageNo ? 'active' : ''"
                class="page-item"
                v-for="index of Pcount"
                :key="index"
                @click="curPage(index)"
              >
                <a class="page-link" v-if="index <= 20">{{ index }}</a>
                <a class="page-link" v-if="index > 20 && index == Pcount - 1"
                  >...</a
                >
                <a class="page-link" v-if="index > 20 && index == Pcount">{{
                  Pcount
                }}</a>
              </li>

              <li
                class="page-item"
                :class="PageNo >= Pcount ? 'disabled' : ''"
                @click="nextPage()"
              >
                <a aria-label="Next" class="page-link">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>

        <!-- <div class="row p-0 m-0">
            <p>
            <span>
            查询数量总计：<span class="money">¥{{totalNum}}</span>
            </span>
            <span>
            (真实)销售金额总计: <span class="money">¥{{totalMoney}}</span>
            </span>
            <span>
            (真实)费用合计: <span class="money">¥{{feeMoney}}</span>
            </span>

            <span></span>
            显示<span class="record">{{PageNo}}</span>-<span class="record">{{Pcount}}</span>条,
            </span>
            <span>
            总共<span class="record">{{Record}}</span>条数据
            </span>

            </p>
            </div> -->
      </div>
    </div>

    <div
      v-show="Pcount === 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2">
          <img
            src="../../static/images/kucun_1.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            结算查询
          </span>
          <span class="ml-5">
            <span>
              显示<span class="record">{{ PageNo }}</span
              >-<span class="record">{{ Pcount }}</span
              >页,
            </span>
            <span>
              总共<span class="record">{{ Record }}</span
              >条数据
            </span>
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>

        <img
          src="../../static/images/wushuju.jpg"
          style="width: 300px; height: 300px; display: block; margin: 0 auto"
          alt=""
        />
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>

        <!-- <div class="row p-0 m-0">
                                <p>
                                       <span>
                                                    查询数量总计：<span class="money">¥{{totalNum}}</span>
                                      </span>
                                      <span>
                                                    (真实)销售金额总计: <span class="money">¥{{totalMoney}}</span>
                                      </span>
                                      <span>
                                                  (真实)费用合计: <span class="money">¥{{feeMoney}}</span>
                                      </span>

                                       <span>
                                            显示<span class="record">{{PageNo}}</span>-<span class="record">{{Pcount}}</span>条,
                                      </span>
                                      <span>
                                           总共<span class="record">{{Record}}</span>条数据
                                      </span>

                                </p>
                       </div> -->
      </div>
    </div>

    <!-- 表单内容 -->
    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>

    <!-- Footer -->
    <!-- <mfooter></mfooter> -->
  </div>
</template>
<script>
// import mheader from '../components/Header.vue'
// import mfooter from '../components/Footer.vue'
import Loading from "../components/Loading.vue";

export default {
  name: "SaleQuery",
  data() {
    return {
      Height: 0,
      searchData: [], //搜索返回的清单
      isLoading: false,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      totalNum: "",
      totalMoney: "",
      feeMoney: "",
    };
  },
  components: {
    // mheader,
    // mfooter,
    Loading,
  },
  computed: {},
  filters: {
    getTrue: function (result) {
      if (result) {
        return "是";
      }
      if (!result) {
        return "否";
      }
    },
  },
  methods: {
    //改变宽度
    changeWidth: function (e) {},
    getClerkSettlementQuery: async function (PageIndex) {
      // this.isLoading=true;
      this.PageNo = PageIndex || this.PageNo;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "ClerkSettlementQuery",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
        }),
      });
      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        this.tableData = obj.rows;
        this.Pcount = obj.pcount;
        this.Record = obj.record;
        this.totalNum = obj.totalNum;
        this.totalMoney = obj.totalMoney;
        this.feeMoney = obj.feeMoney;
      }
    },

    // 当前页
    curPage: function (index) {
      this.getClerkSettlementQuery(index);
    },
    //上一页
    prePage: function () {
      if (this.PageNo > 1) {
        this.PageNo--;

        this.getClerkSettlementQuery(this.PageNo);
      }
    },
    //下一页
    nextPage: function () {
      if (this.PageNo < this.Pcount) {
        this.PageNo++;

        this.getClerkSettlementQuery(this.PageNo);
      }
    },
    //搜索功能
    // 打印
    start_print() {
      this.$print(this.$refs.print); //$refs的值要和html里的ref一致
    },
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    this.getClerkSettlementQuery();
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.money {
  color: red;
  font-weight: 500;
}
.record {
  color: green;
  font-weight: 500;
}
.sett {
  width: 1300px;
  table-layout: fixed;
}
.sett-td {
  white-space: nowrap;

  overflow: hidden;

  text-overflow: ellipsis;

  -moz-text-overflow: ellipsis;
}
.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}
.autocut:hover {
  overflow: visible;
  width: 200px;
  white-space: nowrap;
  word-wrap: break-word;
  text-align: center;
}
.span_close:hover {
  color: #3190e8;
}
</style>



// WEBPACK FOOTER //
// src/pages/SettlementQuery.vue